import { LifecycleCompositeManager } from "../../core/internal/lifecycle/LifecycleComposite"
import { WebViewConfig } from "./HackleWebViewConfiguration"
import { InternalConfig } from "../configuration/index.browser"
import { BrowserHackleClient } from "../index.browser"
import { HackleAppInvocationProcessor } from "./invocator/HackleAppInvocationProcessor"
import BrowserPropertyProvider from "../property/BrowserPropertyProvider"

export default abstract class AbstractHackleWebAppClientFactory {
  constructor(
    protected readonly sdkKey: string,
    protected readonly config: InternalConfig,
    protected readonly invocationProcessor: HackleAppInvocationProcessor,
    protected readonly browserPropertyProvider: BrowserPropertyProvider,
    protected readonly lifecycleCompositeManager: LifecycleCompositeManager
  ) {}

  abstract create(webViewConfig: WebViewConfig): BrowserHackleClient
}
